import { render, staticRenderFns } from "./ActionsUser.vue?vue&type=template&id=1647922a&"
import script from "./ActionsUser.vue?vue&type=script&lang=js&"
export * from "./ActionsUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/tempos21/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('1647922a', component.options)
    } else {
      api.reload('1647922a', component.options)
    }
    module.hot.accept("./ActionsUser.vue?vue&type=template&id=1647922a&", function () {
      api.rerender('1647922a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Layout/SystemManagement/users-management/users-list/ActionsUser.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/SystemManagement/users-management/users-list/ActionsUser.vue
// module id = 7Xe1
// module chunks = 0